package shared.ui.components

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import AppState
import features.teams.handlers.switchTab

object Tab {
    fun render(parent: DIV, tabId: String, label: String, hasSoonBadge: Boolean = false) {
        val isActive = AppState.currentTab == tabId
        val activeClass = if (isActive) "active bg-brand-cyan text-white" else "bg-dark-800 text-slate-400 hover:text-white"
        
        parent.button(classes = "tab-btn px-6 py-2 rounded-lg font-medium transition $activeClass relative") {
            onClickFunction = { switchTab(tabId) }
            +label
            
            if (hasSoonBadge) {
                span("absolute -top-2 -right-2 px-1.5 py-0.5 rounded bg-amber-500 text-[10px] font-bold text-black rotate-12 shadow-sm") {
                    +"Soon"
                }
            }
        }
    }
}
